import { exhaustMap } from "rxjs";
import { authenticatedService } from "../../data-access/api/authenticated/authenticated.service";
import { fetchAuthenticated, fetchAuthenticated_success, } from "./authenticated.actions";
const AuthenticatedEffects = [
    {
        action: fetchAuthenticated,
        operatorFn: () => exhaustMap(() => authenticatedService.fetchAuthenticated().pipe(exhaustMap((authenticated) => {
            return [
                fetchAuthenticated_success({ authenticated }),
            ];
        }))),
    },
];
export default AuthenticatedEffects;
